module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ISO 4217 code":"ISO 4217 Code","Sign / Symbol":"Zeichen / Symbol","Select a currency":"Währung auswählen","No currencies found":"Keine Währungen gefunden","New Currency":"Neue Währung","Edit Currency":"Währung bearbeiten","Save":"Speichern","Dismiss":"Abbrechen","Delete":"Löschen"}}')
  delete Component.options._Ctor
}
